// Module
var code = "<div class=\"vui-g-map\"></div>\n";
// Exports
module.exports = code;